import { setupTheming as setupTheming$1, useTheming as useTheming$1 } from "@odin/services";
let _theme = void 0;
const useTheming = () => {
  if (!_theme) {
    console.error("Theme is not set");
  }
  return {
    theme: _theme,
    isTheme
  };
};
const isTheme = (theme) => {
  return (_theme == null ? void 0 : _theme.value) === theme;
};
const setupTheming = (vue, ref, opt) => {
  _theme = ref(opt.theme);
  const themeOptions = {
    theme: opt.theme,
    env: opt.env,
    onTheme: (value) => {
      if (_theme) {
        return _theme.value = value;
      }
      return null;
    }
  };
  setupTheming$1(themeOptions);
  vue.use(themingVuePlugin);
};
const themingVuePlugin = {
  install: (app) => {
    const { theme } = useTheming$1();
    if (_theme) {
      _theme.value = theme;
    }
    app.prototype.$theme = _theme;
  }
};
export {
  setupTheming,
  themingVuePlugin,
  useTheming
};
//# sourceMappingURL=theming.es.js.map
